<template>
  <div class="vip_box">
    <img src="@/assets/img/vip/img_bg.png"
         class="vip_img_bg"
         alt="" />
    <div class="box_bg"></div>
    <div class="box_list"
         v-for="(item, index) in productDetails"
         :key="index">
      <div class="list_wrap">
        <!-- icon_vip_icon.png -->
        <div class="list_top">
          <img class="vip_pic"
               :src="item.icon"
               alt="" />
          <span class="list_name">{{ item.name }}</span>
          <!-- <span class="list_tips">{{ item.tags }}</span> -->
          <img v-if="item.hasPass != 0 && item.hasMember"
               class="tags_img"
               :src="item.tagUrls[0]"
               alt="" />
          <img v-if="item.hasPass && !item.hasMember"
               class="tags_img"
               src="@/assets/img/newpage/img_hydx.png"
               alt="" />
          <!-- v-for="(imgUrl, imgIndex) in getImgs(item.tagUrls)" -->
        </div>
        <div class="list_context">
          <div class="list_money">
            <p class="list_money_color">
              <!-- {{ item.limitStart / 100 }}～{{ item.limitEnd / 100 }} -->
              {{ item.limit }}
            </p>
            <p class="list_money_tips">额度(元)</p>
          </div>
          <div class="list_month">
            <p class="list_month_time">{{ item.timeLimit }}</p>
            <p class="list_month_tips">{{ item.lendingCycle }}</p>
          </div>
          <div class="list_btn"
               :class="{ new_apply_btn: !item.hasMember }"
               @click="clickNow(item.hasMember, item.memberPageUrl, item.pageUrl,item.id)">
            <!-- 立即申请 -->
            {{ item.hasMember ? "立即申请" : "立即解锁" }}
          </div>
        </div>
        <div class="list_line"></div>
        <div class="list_bot">
          {{ item.feature }}
        </div>
      </div>
    </div>
    <van-overlay :show="show"
                 @click="show = false">
      <div class="wrapper">
        <!-- <div class="block"
             @click.stop /> -->
        <div class="task">
          <img @click.stop="tomember"
               class="task_img"
               src="@/assets/img/vip/img_tc_1.png"
               alt="" />
          <img class="task_close_img"
               src="@/assets/img/vip/icon_close.png"
               alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "vipExclusive",
  components: {},
  data () {
    return {
      productDetails: [], //数据列表
      show: false,
      memberPageUrl: "",
      pageUrl: "",
    };
  },
  mounted () {
    this.util.title("会员独享专区");
  },
  created () {
    this.getDetail();
  },
  methods: {
    tomember () {
      window.location.href = this.memberPageUrl;
    },
    // getImgs(tagUrls) {
    //   if (tagUrls) {
    //     return tagUrls.split(",");
    //   }
    // },
    getDetail () {
      this.$get("/app/api/v2/home/memberProductList")
        .then((res) => {
          if (res.code == 200) {
            // console.log(res.data);
            this.productDetails = res.data;
          } else {
            this.util.toast({ msg: res.message });
          }
        })
        .catch((error) => { });
    },
    clickNow (hasMmeber, memberPageUrl, pageUrl, id) {
      console.log(hasMmeber, memberPageUrl, pageUrl);
      this.memberPageUrl = memberPageUrl;
      this.pageUrl = pageUrl;
      let json = {
        event_key: 'h5_viplist_product_click',
        url: memberPageUrl,
        os: localStorage.getItem("os"),
        app_market_channel: localStorage.getItem("appMarketChannel"),
        app_version: localStorage.getItem("appVersion"),
        customer_id: localStorage.getItem("customerId"),
        udid: localStorage.getItem("udid"),
        package_name: localStorage.getItem("packageName"),
        product_id: id
      }
      this.toCountPoint(json);
      if (!hasMmeber) {
        this.show = true;
      } else {
        window.location.href = this.pageUrl;
      }
    },
    //统计埋点
    toCountPoint (json) {
      this.$get('/app/api/v1/newEventTrace', json)
        .then(res => {
          if (res.code == 200) {
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
  },
};
</script>

<style scoped>
.vip_box {
  position: relative;
  background: rgba(247, 247, 247, 1);
}
.vip_img_bg {
  width: 100%;
  height: 1.3rem;
  display: block;
}
.box_bg {
  width: 100%;
  height: 0.11rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.1rem 0.1rem 0px 0px;
  position: absolute;
  top: 1.195rem;
}
.box_list {
  width: 100%;
}
.list_wrap {
  width: 100%;
  height: 1.47rem;
  background: rgba(255, 255, 255, 1);
  padding: 0 0.15rem;
  margin-bottom: 0.1rem;
}
.list_top {
  padding-top: 0.1rem;
  display: flex;
  align-items: center;
}
.vip_pic {
  width: 0.22rem;
  height: 0.22rem;
}
.list_name {
  font-size: 0.16rem;
  font-weight: bold;
  color: #333333;
  margin-left: 0.06rem;
}
.list_tips {
  padding: 0.03rem 0.04rem;
  background: rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: rgba(255, 172, 72, 1);
  font-size: 0.12rem;
  margin-left: 0.06rem;
}
.list_context {
  margin-top: 0.18rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list_money {
  min-width: 1.5rem;
}
.list_money_color {
  color: #ff514a;
  font-size: 0.2rem;
  font-weight: bold;
}
.list_money_tips {
  color: #666666;
  font-size: 0.12rem;
}
.list_month {
  min-width: 1.1rem;
}
.list_month_time {
  color: #484848;
  font-size: 0.2rem;
  font-weight: bold;
}
.list_month_tips {
  color: #666666;
  font-size: 0.12rem;
}
.list_btn {
  /* padding: 0.09rem 0.16rem; */
  width: 0.8rem;
  height: 0.3rem;
  text-align: center;
  line-height: 0.3rem;
  /* background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  ); */
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 15px;
  font-size: 0.12rem;
  color: #ffffff;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
}
.list_line {
  width: 100%;
  height: 0.01rem;
  background: rgba(245, 245, 245, 1);
  margin-top: 0.15rem;
}
.list_bot {
  margin-top: 0.05rem;
  color: #666666;
  font-size: 0.14rem;
}
.new_apply_btn {
  background: linear-gradient(
    132deg,
    rgba(68, 68, 68, 1) 0%,
    rgba(25, 28, 35, 1) 100%
  );
  box-shadow: 0 0.06rem 0.1rem 0 rgba(0, 0, 0, 0.08);
  border-radius: 0.15rem;
  color: #fff2e1;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.task_img {
  width: 2.55rem;
  height: auto;
}
.task_close_img {
  width: 0.3rem;
  height: auto;
  margin-top: 0.4rem;
}
.task {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tags_img {
  width: 0.32rem;
  height: 0.13rem;
  margin-left: 0.06rem;
}
>>> .van-overlay {
  background-color: rgba(0, 0, 0, 0.4);
}
</style>
